import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class CorePreloadingStrategy implements PreloadingStrategy {

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // Preloading is deliberately OFF. Firing 8+ lazy-module loads in one
    // sweep right after login locks the main thread for minutes inside the
    // injector graph walk (Angular 10) and ends in an RxJS stack overflow
    // that leaves the router dead — the post-login "frozen strips" screen.
    // On-demand loading of the same modules is instant, so nothing is lost.
    // Do not re-enable via route data without re-testing a patient login.
    return of(null);
  }
}
